var DespachoDiario = (function () {
    function DespachoDiario(expediente, caratula, organismosecretaria, decreto) {
        this.expediente = expediente;
        this.caratula = caratula;
        this.organismosecretaria = organismosecretaria;
        this.decreto = decreto;
    }
    return DespachoDiario;
}());
export { DespachoDiario };
var DespachoPage = (function () {
    function DespachoPage(page, size, total, data) {
        this.page = page;
        this.size = size;
        this.total = total;
        this.data = data;
    }
    return DespachoPage;
}());
export { DespachoPage };
var DespachoFilter = (function () {
    function DespachoFilter(fecha_desde, fecha_hasta, caratula, habil, favorito, cir_id, org_id, sec_id, numero, anio, page, size, usrCod, documento, tipoDoc) {
        this.fecha_desde = fecha_desde;
        this.fecha_hasta = fecha_hasta;
        this.caratula = caratula;
        this.habil = habil;
        this.favorito = favorito;
        this.cir_id = cir_id;
        this.org_id = org_id;
        this.sec_id = sec_id;
        this.numero = numero;
        this.anio = anio;
        this.page = page;
        this.size = size;
        this.usrCod = usrCod;
        this.documento = documento;
        this.tipoDoc = tipoDoc;
    }
    return DespachoFilter;
}());
export { DespachoFilter };
//# sourceMappingURL=despacho-diario.js.map